// Styles
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { headerHeight } from '../../scripts/helpers';
import './horizontal-scroll.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initHorizontalScroll = (context) => {
  const horizontalScrollSection = context.closest('.shopify-section');
  if (!horizontalScrollSection) return;

  let mm = gsap.matchMedia();

  mm.add("(min-width: 1025px)", () => {
    const container = horizontalScrollSection.querySelector('.horizontal-scroll__container');
    const scrollWrapper = horizontalScrollSection.querySelector('.horizontal-scroll__scroll-wrapper');
    if (scrollWrapper && container && scrollWrapper.clientWidth < scrollWrapper.scrollWidth) {
      gsap.registerPlugin(ScrollTrigger);
      gsap.to(scrollWrapper, {
        x: (scrollWrapper.clientWidth - scrollWrapper.scrollWidth - 100),
        scrollTrigger: {
          ease: 'none',
          trigger: container,
          start: `top ${headerHeight()}`,
          end: `+=${scrollWrapper.scrollWidth}`,
          pin: true,
          scrub: true,
          markers: false
        }
      });
    }
  })
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.horizontal-scroll__container'), (el) => {
    window.dAgency.initHorizontalScroll(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.horizontal-scroll__container'), (el) => {
      window.dAgency.initHorizontalScroll(el);
    });
  });
}
